export enum VisibilityState {
  Hidden = 'hidden',
  Visible = 'visible',
}
